import React, { useEffect, useState, useMemo } from 'react';
import StyledContainer from 'views/experience-module/MotorcycleTripsView/MotorcycleTripsView.styles';
import { useTranslation } from 'next-i18next';
import Typography500 from 'views/common/components/UI/Typography500';
import {
  DestinationCard,
  ParagraphWithEmbeddedObjects,
} from 'views/common/components';
import {
  Grid, useMediaQuery, useTheme, Box,
} from '@mui/material';
import { API } from 'lib/config/axios';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import { MotorcycleTripsViewSkeleton } from 'views/experience-module/MotorcycleTripsView/MotorcycleTripsViewSkeleton';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import PATHS from 'lib/navigation/paths';
import { useSelector } from 'react-redux';
import useGetLayout from 'views/common/hooks/useGetLayout';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';

const MotorcycleTripsView = (props) => {
  const { serverData } = props;
  const { t } = useTranslation('fe_er_motorcycle_trips_page');
  const [data, setData] = useState(serverData);
  const [isLoaded, setIsLoaded] = useState(!!serverData);
  const theme = useTheme();
  const { getPageData } = useGetLayout();
  const handleErrorResponse = useErrorsHandler();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  const imageSize = useMemo(() => {
    if (isMobile || isCrawler) {
      return 'small_url';
    }
    if (isTablet) {
      return 'medium_url';
    }
    return 'large_url';
  }, [isTablet, isMobile]);
  const getData = async () => {
    setIsLoaded(false);
    try {
      const [, tripsRes] = await getPageData(API.motorcycleTrips.index);

      setData(tripsRes.data);
      setIsLoaded(true);
    } catch (error) {
      handleErrorResponse(error, false);
    }
  };
  useEffect(() => {
    if (!serverData && !isCrawler) {
      getData();
      window.gtag('event', 'landing_page_view', {
        page_identifier: PAGES_GA_IDENTIFIERS.EXPERIENCE_LISTING,
      });
    }
  }, []);
  return (
    <>
      {isLoaded ? (
        <>
          {data?.seo_values && <Head>{generateMetaData(data.seo_values)}</Head>}
          <StyledContainer maxWidth="xl" className="MTVContainer">
            <Typography500 className="MTVTitle" component="h1" variant="h2">
              {t('fe_er_motorcycle_trips_page:popular_motorcycle_trips')}
            </Typography500>
            <Grid container spacing={3}>
              {data.trips.map((trip) => (
                <Grid item xs={12} md={6} lg={4} key={trip.slug}>
                  <DestinationCard
                    title={`${trip.name} ${t(
                      'fe_er_motorcycle_trips_page:motorcycle_trips',
                    )}`}
                    image={{
                      src: trip.cover_image[imageSize],
                      alt: `${trip.name} ${t(
                        'fe_er_motorcycle_trips_page:motorcycle_trips',
                      )}`,
                    }}
                    link={PATHS.motorcycleTrips.slug(trip.slug)}
                    titleComponent="h2"
                  />
                </Grid>
              ))}
            </Grid>
            <Box py={4}>
              <ParagraphWithEmbeddedObjects
                title={t(
                  'fe_er_motorcycle_trips_page:popular_motorcycle_trips_experience',
                )}
                desc={t(
                  'fe_er_motorcycle_trips_page:popular_motorcycle_trips_experience_desc',
                )}
                collapsedSize={100}
              />
            </Box>
          </StyledContainer>
        </>
      ) : (
        <MotorcycleTripsViewSkeleton />
      )}
    </>
  );
};

export { MotorcycleTripsView };
